<template>
  <div class="industry">
    <div id="gd-map"></div>
    <div id="panel"></div>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
window._AMapSecurityConfig = {
  // 设置安全密钥
  securityJsCode: "81adcfddc82b3947d9a9839b0f72d74d",
};
export default {
  name: "industryChain",
  props: {
    selectedKey: {
      type: String,
      required: true,
    },
    modalConfigHandle: {
      type: Function,
    },
  },
  data() {
    return {
      map: null,
      mouseTool: null,
      overlays: [],
      auto: null,
      placeSearch: null,
      longitude: "",
      latitude: "",
      type: "",
      icon: "",
      //美食推荐
      selectedMarker: null,
      mapCtr: null,
      driving: null,
    };
  },
  watch: {},
  async mounted() {
    //初始化地图构造函数mapCtr实例
    const mapCtr = await this.initMapConstructor();
    this.mapCtr = mapCtr;
    //通过构造mapCtr创建地图并返回map实例
    this.initMap(mapCtr);
    this.$emit("initFinish");
  },
  methods: {
    initMap(mapCtr) {
      this.map = new mapCtr.Map("gd-map", {
        resizeEnable: true,
        viewMode: "3D",
        zoomEnable: true,
        dragEnable: true,
        doubleClickZoom: true,
        zoom: 17,
        showBuildingBlock: true,
        center: [106.212566, 37.983458],
      });
      // 设置限制区域为吴忠市的边界矩形
      const bounds = new mapCtr.Bounds(
        [105.531165, 37.711398],
        [106.86731, 38.518059]
      );
      this.map.setLimitBounds(bounds);
    },

    initMapConstructor() {
      return AMapLoader.load({
        key: "a46d1b08b3d0e86cffc3faadd79f8417",
        version: "2.0",
        plugins: [
          "AMap.Scale",
          "AMap.ToolBar",
          "AMap.ControlBar",
          "AMap.Geocoder",
          "AMap.Marker",
          "AMap.Bounds",
          "AMap.Driving",
          "AMap.CitySearch",
          "AMap.Geolocation",
          "AMap.AutoComplete",
          "AMap.InfoWindow",
        ],
      });
    },
    addMapPoints(points, key) {
      const mapCtr = this.mapCtr;
      this.map.clearMap(); // 清除地图上的所有标记点
      // 添加选中的坐标标记点到地图上
      points.forEach((item) => {
        const size = key === "food" ? 40 : 70;
        const iconSize = new mapCtr.Size(size, size);
        const imageSize = new mapCtr.Size(size, size);
        const icon = new mapCtr.Icon({
          size: iconSize, // 图标尺寸
          image: item.icon
            ? item.icon
            : require("../assets/images/mapPoint.png"), // Icon的图像

          imageSize: imageSize, // 根据所设置的大小拉伸或压缩图片
        });
        const marker = new mapCtr.Marker({
          map: this.map,
          zIndex: 9999999,
          offset: new mapCtr.Pixel(-13, -30),
          position: item.lnglats,
          icon: icon, // 添加 Icon 图标 URL
          label: {
            content: item.name, // 标记点的名称
            offset: new mapCtr.Pixel(5, 0), // 偏移量，用于调整标记点名称的位置
          },
        });
        // 添加点击事件监听器
        marker.on("click", () => {
          this.selectedMarker = item;
          this.open();
        });
        this.map.add(marker); // 添加标记点到地图上
      });
      this.map.setFitView(); // 调整地图视野以适应所有标记点的显示
    },
    drawRouteLines(points) {
      const mapCtr = this.mapCtr;
      this.map.clearMap(); // 清除地图上的所有标记点
      //构造路线导航类
      if (this.driving !== null) {
        this.driving.clear();
      } else {
        this.driving = new mapCtr.Driving({
          map: this.map,
          panel: "panel",
        });
      }
      // 根据起终点名称规划驾车导航路线
      this.driving.search(points, function (status, result) {
        if (status === "complete") {
          console.log("绘制驾车路线完成");
        } else {
          console.error("获取驾车数据失败：" + result);
        }
      });
    },
    // 弹框事件
    open() {
      // 检查是否有选中的marker
      if (this.selectedMarker) {
        const handleConfig = this.modalConfigHandle(this.selectedMarker);
        if (handleConfig) {
          this.$notify({
            title: handleConfig.name,
            message: handleConfig.content,
          });
        }
      } else {
        this.$notify({
          title: "未选中marker",
          message: "请选择一个marker来查看信息",
        });
      }
    },
  },
};
</script>

<style scoped>
#gd-map {
  overflow: hidden;
  width: 100%;
  height: 800px;
  margin: 0 auto;
}
::v-deep .amap-marker-label {
  position: absolute;
  z-index: 2;
  border: none;
  background-color: #fff;
  white-space: nowrap;
  cursor: default;
  padding: 3px;
  font-size: 14px;
  line-height: 14px;
}
::v-deep .amap-icon img {
  position: absolute;
  z-index: -1;
  border-radius: 50%;
}
</style>
<style>
/* 隐藏高德logo  */
.amap-logo {
  display: none !important;
}
/* 隐藏高德版权  */
.amap-copyright {
  display: none !important;
}
#panel {
  position: fixed;
  background-color: white;
  max-height: 65%;
  overflow-y: auto;
  top: 75px;
  right: 44px;
  width: 245px;
}
#panel .amap-call {
  background-color: #009cf9;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
#panel .amap-lib-driving {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  overflow: hidden;
}
</style>
